export class RegularExpressionConstant {
    static EMAIL: RegExp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static date: RegExp = /^[0-9]{2}-[0-9]{2}-[0-9]{4}( [0-9]{2}:[0-9]{2})?/;
    static PASSWORD: RegExp =
        /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^\sa-zA-Z0-9]).*$/;

    static SERVER_INTERNAL_ERROR: RegExp = /^5\d{2}$/;
}
